import { OutlineElement } from '@phase2/outline-core';
import { html, TemplateResult, CSSResultArray } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { AdoptedStyleSheets } from '@phase2/outline-adopted-stylesheets-controller';

import globalStyles from './pc-person-card.lightDom.css.lit';
import componentStyles from './pc-person-card.css.lit';

/**
 * Insight Person Card component
 * @element pc-person-card
 * @slot - This element has a default slot
 */
@customElement('pc-person-card')
export class PCPersonCard extends OutlineElement {
  static styles: CSSResultArray = [componentStyles];

  adoptedStylesheets: AdoptedStyleSheets;

  @property({ type: String, attribute: 'layout' })
  layout: 'inline' | 'stacked' = 'stacked';

  @property({ type: Boolean, attribute: 'has-border-x' })
  hasBorderX: boolean;

  _hasImage = false;

  connectedCallback() {
    super.connectedCallback();

    this.adoptedStylesheets = new AdoptedStyleSheets(globalStyles);
    this.addController(this.adoptedStylesheets);

    this._hasImage = Boolean(this.querySelector('[slot="image"]'));
  }

  renderImageSlot() {
    if (!this._hasImage) {
      return null;
    }

    return html`<div class="image"><slot name="image"></slot></div>`;
  }

  render(): TemplateResult {
    return html`
      <div
        class="person-card ${this.hasBorderX ? 'has-border-x' : ''} ${this
          .layout}"
      >
        ${this.renderImageSlot()}
        <div class="content">
          <slot name="name"></slot>
          <slot name="title"></slot>
          <slot name="detail"></slot>
          <slot name="location"></slot>

          <div class="contact">
            <slot name="contact"></slot>
          </div>
        </div>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-person-card': PCPersonCard;
  }
}
